// extracted by mini-css-extract-plugin
export default {"contentfulHeroContainer":"ContentfulHero-module__contentfulHeroContainer__p8NpZ9Z","heroVideo":"ContentfulHero-module__heroVideo__AKHWF5B"};